import Home from "pages/Home/Home";
import { RouteObject, createBrowserRouter } from "react-router-dom";
import { settingsRoute } from "./modules";

const routes: RouteObject[] = [
  {
    path: "",
    element: <Home />,
  },
  ...settingsRoute,
  {
    path: "*",
    element: <div>Page Not Found!</div>,
  },
];

const router = createBrowserRouter(routes);

export { router };
